// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let BroadcastSearchResultTimestamp = require("../BroadcastSearchResultTimestamp.bs.js");
let PropertySearchResultTimestamp_propertyV5_graphql = require("../../../__generated__/PropertySearchResultTimestamp_propertyV5_graphql.bs.js");

let convertFragment = PropertySearchResultTimestamp_propertyV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertySearchResultTimestamp_propertyV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertySearchResultTimestamp_propertyV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertySearchResultTimestamp_propertyV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertySearchResultTimestamp_propertyV5_graphql.node, convertFragment, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertySearchResultTimestamp(props) {
  let match = RescriptRelay_Fragment.useFragment(PropertySearchResultTimestamp_propertyV5_graphql.node, convertFragment, props.property);
  return JsxRuntime.jsx(BroadcastSearchResultTimestamp.make, {
    updatedAt: match.updatedAt,
    broadcastAt: match.broadcastAt
  });
}

let make = PropertySearchResultTimestamp;

exports.PropertyFragment = PropertyFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
